/* BundleOverview.tab.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { media } from '@atlaskit/primitives';
import { MediaViewer } from '@atlassian/mpac-primitives';
import { AtlassianProductHostingType } from '@atlassian/mpac-types/graphql-gateway-types';
import { Hero, Highlights, MoreDetails, PrivacyAndSecurity, SupportingMedia, useMedia } from '@atlassian/mpac-ui';
import { AppsInBundle } from './AppsInBundle';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _19 = "._1ul91h0h{min-width:18rem}";
const _18 = "._16jlegat{flex-grow:4}";
const _17 = "@media not all and (min-width:64rem){._2osnoahv{gap:var(--ds-space-600,3pc)}._blhd1osq{min-width:100%}}";
const _16 = "._1ul9bejm{min-width:31.25rem}";
const _15 = "._2lx21bp4{flex-direction:column}";
const _14 = "._i0dlf1ug{flex-basis:0%}";
const _13 = "._1o9zkb7n{flex-shrink:1}";
const _12 = "._16jl37uc{flex-grow:8}";
const _11 = "._zulpxy5q{gap:var(--ds-space-400,2pc)}";
const _10 = "._1n261g80{flex-wrap:wrap}";
const _9 = "._1bah1h6o{justify-content:center}";
const _8 = "._4cvr1y6m{align-items:flex-start}";
const _7 = "._2lx2vrvc{flex-direction:row}";
const _6 = "._1e0c1txw{display:flex}";
const _5 = "._zulpoahv{gap:var(--ds-space-600,3pc)}";
const _4 = "@media not all and (min-width:64rem){._8fz6147l{max-width:44rem}}";
const _3 = "._1tkebejm{min-height:31.25rem}";
const _2 = "._1bsb1osq{width:100%}";
const _ = "._1yt4j3ea{padding:var(--ds-space-400,2pc) 0 var(--ds-space-800,4pc) 0}";
const BundleOverview = _ref => {
  var _heroImage$url;
  let {
    name,
    heroImage,
    highlights,
    screenshots,
    tagline,
    privacyPolicy,
    youtubeId,
    trustCenterUrl,
    moreDetails
  } = _ref;
  const {
    activeMedia,
    mediaItems,
    handleMediaClick,
    unsetActiveMedia
  } = useMedia(highlights, screenshots);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3]
    }), /*#__PURE__*/_jsxs("div", {
      className: ax(["_1yt4j3ea _1bsb1osq _1tkebejm"]),
      children: [/*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_4]
        }), /*#__PURE__*/_jsxs("div", {
          className: ax(["_8fz6147l"]),
          children: [/*#__PURE__*/_jsx(Hero, {
            tagline: tagline !== null && tagline !== void 0 ? tagline : '',
            heroImage: {
              url: (_heroImage$url = heroImage === null || heroImage === void 0 ? void 0 : heroImage.url) !== null && _heroImage$url !== void 0 ? _heroImage$url : '',
              width: 1920,
              height: 1080
            },
            youtubeId: youtubeId,
            listingName: name,
            ariaLabel: tagline !== null && tagline !== void 0 ? tagline : ''
          }), /*#__PURE__*/_jsx(Highlights, {
            highlights: highlights || [],
            onMediaItemClick: mediaItem => {
              handleMediaClick(mediaItem);
            }
          })]
        })]
      }), /*#__PURE__*/_jsx(SupportingMedia, {
        screenshots: screenshots,
        onMediaItemClick: mediaItem => {
          console.log(mediaItem);
          handleMediaClick(mediaItem);
        }
      }), activeMedia && /*#__PURE__*/_jsx(MediaViewer, {
        mediaItems: mediaItems,
        selectedMediaItem: activeMedia,
        onClose: unsetActiveMedia
      }), /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_5, _6, _7, _8, _9, _10, _2]
        }), /*#__PURE__*/_jsxs("div", {
          className: ax(["_zulpoahv _1e0c1txw _2lx2vrvc _4cvr1y6m _1bah1h6o _1n261g80 _1bsb1osq"]),
          children: [/*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_11, _12, _13, _14, _6, _15, _16, _2, _17]
            }), /*#__PURE__*/_jsxs("div", {
              className: ax(["_zulpxy5q _16jl37uc _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _1ul9bejm _1bsb1osq _2osnoahv _blhd1osq"]),
              children: [/*#__PURE__*/_jsx(MoreDetails, {
                moreDetails: moreDetails !== null && moreDetails !== void 0 ? moreDetails : ''
              }), /*#__PURE__*/_jsx(AppsInBundle, {})]
            })]
          }), /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_11, _18, _13, _14, _6, _15, _19, _2, _17]
            }), /*#__PURE__*/_jsx("div", {
              className: ax(["_zulpxy5q _16jlegat _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _1ul91h0h _1bsb1osq _2osnoahv _blhd1osq"]),
              children: /*#__PURE__*/_jsx(PrivacyAndSecurity, {
                privacyPolicyUrl: privacyPolicy !== null && privacyPolicy !== void 0 ? privacyPolicy : '',
                partnerType: undefined // TODO: check if we need to distinguish between partner types (external/ atlassian internal)
                ,
                appName: name,
                hosting: AtlassianProductHostingType.Cloud,
                showSecurityProgramSection: false,
                bugBountyParticipant: undefined,
                privacySecurityQuestionsState: "not_applicable",
                showIntegrationsDetailsSection: false,
                trustCenterUrl: trustCenterUrl !== null && trustCenterUrl !== void 0 ? trustCenterUrl : ''
              })
            })]
          })]
        })]
      })]
    })]
  });
};
export default BundleOverview;
const TabContentContainer = null;
const HeroAndHighlightsContainer = null;
const TwoColumns = null;
const LeftColumn = null;
const RightColumn = null;